<script setup>
import { computed } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import ButtonV4 from 'dashboard/components-next/button/Button.vue';
import TicketsAPI from 'dashboard/api/tickets';

const props = defineProps({
  ticket: { type: Object, required: true },
});

const store = useStore();
const { t } = useI18n();

const isOverdue = computed(() => {
  if (!props.ticket.due_at) return false;
  if (['resolved', 'closed'].includes(props.ticket.state)) return false;
  return new Date(props.ticket.due_at) < new Date();
});

const notificationLabel = computed(() => {
  const map = {
    sent: t('TICKETING.PANEL.NOTIFICATION_SENT'),
    skipped: t('TICKETING.PANEL.NOTIFICATION_SKIPPED'),
    failed: t('TICKETING.PANEL.NOTIFICATION_FAILED'),
  };
  return map[props.ticket.customer_notification_status] || '';
});

const retry = async () => {
  await TicketsAPI.retryCustomerNotification(props.ticket.ticket_number);
  await store.dispatch('tickets/fetchTicket', props.ticket.ticket_number);
};
</script>

<template>
  <div class="flex flex-col gap-3 text-sm">
    <div class="font-medium text-n-slate-12">{{ ticket.ticket_number }}</div>
    <div>{{ ticket.title }}</div>
    <div v-if="ticket.due_at" :class="isOverdue ? 'text-n-ruby-11' : ''">
      {{ ticket.due_at }}
      <span v-if="isOverdue"> — {{ $t('TICKETING.PANEL.OVERDUE') }}</span>
    </div>
    <div v-if="notificationLabel">{{ notificationLabel }}</div>
    <ButtonV4
      v-if="ticket.customer_notification_status === 'failed'"
      size="sm"
      :label="$t('TICKETING.PANEL.RETRY_NOTIFICATION')"
      @click="retry"
    />
  </div>
</template>
